import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { ApplicationPaths } from '../../services/ApplicationPaths'
import { setThemeColor } from './Utility'

export const RouteChangeListener = () => {
  const history = useHistory()

  const pathList = [...ApplicationPaths.protected, ...ApplicationPaths.unprotected]

  const applyTheme = (location) => {
    const path = pathList.find((p) => location.pathname.startsWith(p.path))
    setThemeColor(path?.application)
  }

  useEffect(() => {
    if (!history) return

    applyTheme(history.location)

    const unlisten = history.listen((location) => {
      applyTheme(location)
    })

    return () => unlisten()
  }, [])

  return null
}
